import classNames from "classnames";
import {parse, format} from "date-fns";

import * as models from "liberty-core/api/models";

import styles from "./TimePicker.module.css";

type Props = {
  className?: string;
  allTimes: models.TimeString[];
  availableTimes: models.TimeString[];
  selectedTime: models.TimeString;
  onClick: (time: models.TimeString) => void;
};

export default function TimePicker(props: Props) {
  const boxList: JSX.Element[] = [];
  props.allTimes.forEach((time) => {
    const parsedTime = parse(time, "HH:mm", new Date());
    boxList.push(
      <button
        key={time}
        className={classNames(
          props.selectedTime === time ? styles.selectedBox : null,
          styles.box,
        )}
        disabled={
          !props.availableTimes.find((availableTime) => availableTime === time)
        }
        onClick={() => props.onClick(time)}
      >
        {format(parsedTime, "p")}
      </button>,
    );
  });

  return (
    <div className={classNames(styles.container, props.className)}>
      {boxList}
    </div>
  );
}
